import React from "react";
import { ChatStatus } from "../../../../__generated__/api";
import { TicketItem } from "../../../../contexts/ticket-state";
import Badge from "../../../theme/badge/Badge";

const STATUS_TEXT = {
    [ChatStatus.Assigned]: "Assigned",
    [ChatStatus.ChatRequested]: "Waiting",
    [ChatStatus.Connected]: "Connected",
    [ChatStatus.Finished]: "Finished",
    [ChatStatus.Ignored]: "Ignored",
    [ChatStatus.OnHold]: "On Hold",
    [ChatStatus.Snoozed]: "Snoozed",
    [ChatStatus.DeflectionWaiting]: "Deflection Waiting",
};

export default function Status({ ticket }: {
    ticket:TicketItem
}) {
    return (
        <Badge variant="info">
            {STATUS_TEXT[ticket.chat.status]}
        </Badge>
    );
}
